import {useRef} from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {Lead} from 'nutshell-graphql-types';

import {useCoreEntityWorkspaceSidebarCollapsed} from '../../core-entity/hooks/use-core-entity-workspace-sidebar-collapsed';
import {CoreEntityContent} from '../../core-entity/layout/core-entity-content';

import {LeadHeaderMiniOnScroll} from '../header-fixed/lead-header-mini-on-scroll';

import {ActionBar} from './action-bar/action-bar';
import {LeadModals} from './lead-modals';
import {WorkspaceSection} from './workspace-section/workspace-section';

type Props = {
    lead: Lead;
    scrollContainerRef: HTMLDivElement | null | undefined;
    user: User;
    hasScrolledPastCheckpoint: boolean;
    getActionBarRef: (ref: HTMLDivElement | null) => void;
    isSidebarCollapsed: boolean;
    scrollContainerTop: number;
    isLeadRecapFeatureEnabled: boolean;
    hasFullHeightSidebar?: boolean;
};

export function ContentM3(props: Props) {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const {isWorkspaceSidebarCollapsed, handleModeChange} = useCoreEntityWorkspaceSidebarCollapsed(
        props.isSidebarCollapsed,
        'lead'
    );

    return (
        <CoreEntityContent
            contentRef={contentRef}
            hasFullHeightSidebar={props.hasFullHeightSidebar}
        >
            <LeadHeaderMiniOnScroll
                scrollContainerTop={props.scrollContainerTop}
                isShown={props.hasScrolledPastCheckpoint}
                contentRef={contentRef}
                lead={props.lead}
                user={props.user}
            />
            <ActionBar
                lead={props.lead}
                user={props.user}
                getRef={props.getActionBarRef}
                hasScrolledPastCheckpoint={props.hasScrolledPastCheckpoint}
            />
            <WorkspaceSection
                lead={props.lead}
                scrollContainerRef={props.scrollContainerRef}
                user={props.user}
                isSidebarCollapsed={props.isSidebarCollapsed}
                isWorkspaceSidebarCollapsed={isWorkspaceSidebarCollapsed}
                onIsWorkspaceSidebarCollapsedChange={handleModeChange}
                isLeadRecapFeatureEnabled={props.isLeadRecapFeatureEnabled}
                hasFullHeightSidebar={props.hasFullHeightSidebar}
            />
            <LeadModals />
        </CoreEntityContent>
    );
}
